import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMemo } from 'react';
import {
  getAllContributorsCellValue,
  getAllOwnersCellValue,
} from 'src/rbac/contributorHelper';

import { getFriendlyId } from '@/utils/friendlyId';

import type { AssetFields, AssetTableFields } from './types';

export const useLabelledFields = (records: AssetFields[] | undefined) => {
  const status = useRating('asset_status');

  return useMemo<AssetTableFields[]>(() => {
    return (
      records?.map((d) => ({
        ...d,
        StatusLabelled: status.getLabel(d.Status ?? null),
        ModifiedByUserName: d.modifiedByUser?.FriendlyName || '-',
        CreatedByUserName: d.createdByUser?.FriendlyName || '-',
        AssigneeName: d.assigneeUser?.FriendlyName || '-',
        SequentialIdLabel: d.SequentialId
          ? getFriendlyId(Parent_Type_Enum.Asset, d.SequentialId)
          : '',
        allOwners: getAllOwnersCellValue(d),
        allContributors: getAllContributorsCellValue(d),
      })) || []
    );
  }, [records, status]);
};
